import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from "vue";
import { useMainStore } from "@/stores/main";
import Tool from "@/components/tools/Tool.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'WidthSlider',
  setup(__props) {

const store = useMainStore();
const localValue = ref(store.width);

let timer = 0;

watch(
    () => localValue.value,
    () => {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            store.width = localValue.value;
        }, 100);
    }
);

return (_ctx: any,_cache: any) => {
  const _component_v_slider = _resolveComponent("v-slider")!

  return (_openBlock(), _createBlock(Tool, { label: "Poster grootte" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_slider, {
        modelValue: localValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
        min: 100,
        max: 600,
        step: 50,
        "show-ticks": ""
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})